import { Utilities } from "shared/utilities";
import { ISimpleApiSpecificationData } from "../../apiManagement/model/model";
import { IAction } from "../model/IAction";
import { ISubProcessData, ITaskData } from "../model/IProcessData";
import { ITimeZoneEntry } from "../model/ITriggerData";
import { UserSnippet } from "./SnippetActions";

export function fetchItems(apiUri?: string, receiveAction?: (data: any) => IAction) {
    return (dispatch: any) =>
        Utilities.getFetch(apiUri as string)
            .then((data: any) => dispatch(receiveAction && receiveAction(data)));
}

export const RECEIVE_TASKS = "RECEIVE_TASKS";
export function receiveTasks(data: ITaskData[]): IReceiveTasksAction {
    return {
        type: RECEIVE_TASKS,
        tasksData: data
    };
}
export interface IReceiveTasksAction extends IAction {
    tasksData: ITaskData[];
}

export const RECEIVE_ENVIRONMENT_VARIABLES = "RECEIVE_ENVIRONMENT_VARIABLES";
export function receiveEnvironmentVariables(data: string[]): IReceiveEnvironmentVariablesAction {
    return {
        type: RECEIVE_ENVIRONMENT_VARIABLES,
        environmentVariableNames: data
    };
}
export interface IReceiveEnvironmentVariablesAction extends IAction {
    environmentVariableNames: string[];
}

export const RECEIVE_TIMEZONES = "RECEIVE_TIMEZONES";
export function receiveTimeZones(data: ITimeZoneEntry[]): IReceiveTimeZoneAction {
    return {
        type: RECEIVE_TIMEZONES,
        timeZoneData: data
    };
}
export interface IReceiveTimeZoneAction extends IAction {
    timeZoneData: ITimeZoneEntry[];
}

export const RECEIVE_SUB_PROCESSES = "RECEIVE_SUB_PROCESSES";
export function receiveSubProcesses(data: ISubProcessData[]): IReceiveSubProcessesAction {
    return {
        type: RECEIVE_SUB_PROCESSES,
        subProcessData: data
    };
}
export interface IReceiveSubProcessesAction extends IAction {
    subProcessData: ISubProcessData[];
}

export const RECEIVE_API_SPECS = "RECEIVE_API_SPECS";
export function receiveApiSpecs(data: ISimpleApiSpecificationData[]): IReceiveApiSpecsAction {
    return {
        type: RECEIVE_API_SPECS,
        apiSpecData: data
    };
}
export interface IReceiveApiSpecsAction extends IAction {
    apiSpecData: ISimpleApiSpecificationData[];
}

export const RECEIVE_USER_SNIPPETS = "RECEIVE_USER_SNIPPETS";
export function receiveUserSnippets(data: UserSnippet[]): IReceiveUserSnippetsAction {
    return {
        type: RECEIVE_USER_SNIPPETS,
        userSnippets: data
    };
}
export interface IReceiveUserSnippetsAction extends IAction {
    userSnippets: UserSnippet[];
}

export const TCP_TRIGGER_ENABLED = "TCP_TRIGGER_ENABLED";
export function tcpTriggerEnabled(): IAction {
    return {
        type: TCP_TRIGGER_ENABLED
    };
}


export const INTERCOM_DOCUMENTATION_ENABLED = "INTERCOM_DOCUMENTATION_ENABLED";
export function intercomDocumentationEnabled(): IAction {
    return {
        type: INTERCOM_DOCUMENTATION_ENABLED
    };
}

export const EDITOR_READ_ONLY = "EDITOR_READ_ONLY";
export function fetchEditorReadOnly(isEditorReadOnly: boolean): IEditorReadOnlyAction {
    return {
        type: EDITOR_READ_ONLY,
        isEditorReadOnly
    };
}

export interface IEditorReadOnlyAction extends IAction {
    isEditorReadOnly: boolean;
}